import React from "react";
import UserDetailsHeader from "../UserDetailsHeader/UserDetailsHeader";
import PermissionsTable from "../PermissionsTable/PermissionsTable";

export default function UserPermissions() {
    return <PermissionsTable top={<UserDetailsHeader />} />
}